module.exports = __webpack_public_path__ + "static/media/logo_bug2.67cd079d.svg";